import { render, staticRenderFns } from "./ozon-amz-statistics.vue?vue&type=template&id=b064be5e&scoped=true"
import script from "./ozon-amz-statistics.vue?vue&type=script&lang=js"
export * from "./ozon-amz-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b064be5e",
  null
  
)

export default component.exports